module.exports = __webpack_public_path__ + "media/icons/raport_2@3x-1f4e279d.svg";